// extracted by mini-css-extract-plugin
module.exports = {"dark-grey":"#9E9C9C","markerContainer":"Marker_markerContainer__3R98S","marker":"Marker_marker__2tKgU","markerSvg":"Marker_markerSvg__1mqFx"};